module.exports = __webpack_public_path__ + "~@/assets/img/3_browse.a18be15a.png";